import React from "react";
import { Select } from "antd";

export const HelperPaymentMethodSelect = (
  props: React.ComponentProps<typeof Select>
) => {
  return (
    <Select placeholder="grain delivery method" {...props}>
      <Select.Option value={0}>cheque</Select.Option>
      <Select.Option value={1}>bank transfer</Select.Option>
      <Select.Option value={2}>FPS</Select.Option>
      <Select.Option value={3}>WeChat pay</Select.Option>
      <Select.Option value={4}>Ali pay</Select.Option>
      <Select.Option value={5}>cash</Select.Option>
    </Select>
  );
};
